import * as actionTypes from '../types/adminMessages';

export function getMessagesFilter(payload) {
  return {
    type: actionTypes.GET_MESSAGES_FILTER,
    payload
  };
}

export function getMessagesFilterSuccess(payload) {
  return {
    type: actionTypes.GET_MESSAGES_FILTER_SUCCESS,
    payload
  };
}

export function getMessagesFilterFail(payload) {
  return {
    type: actionTypes.GET_MESSAGES_FILTER_FAIL,
    payload
  };
}

export function getMessages(payload) {
  return {
    type: actionTypes.GET_MESSAGES,
    payload
  };
}

export function getMessagesSuccess(payload) {
  return {
    type: actionTypes.GET_MESSAGES_SUCCESS,
    payload
  };
}

export function getMessageTypeFilterFail(payload) {
  return {
    type: actionTypes.GET_MESSAGE_TYPE_FILTER_FAIL,
    payload
  };
}

export function getMessageTypeFilter(payload) {
  return {
    type: actionTypes.GET_MESSAGE_TYPE_FILTER,
    payload
  };
}

export function getMessageTypeFilterSuccess(payload) {
  return {
    type: actionTypes.GET_MESSAGE_TYPE_FILTER_SUCCESS,
    payload
  };
}

export function getMessagesFail(payload) {
  return {
    type: actionTypes.GET_MESSAGES_FAIL,
    payload
  };
}

export function resetMessages(payload) {
  return {
    type: actionTypes.RESET_MESSAGES,
    payload
  };
}

export function resetMessagesSuccess(payload) {
  return {
    type: actionTypes.RESET_MESSAGES_SUCCESS,
    payload
  };
}

export function resetMessagesFail(payload) {
  return {
    type: actionTypes.RESET_MESSAGES_FAIL,
    payload
  };
}

export function getMessageXml(payload) {
  return {
    type: actionTypes.GET_MESSAGE_XML,
    payload
  };
}

export function getMessageXmlSuccess(payload) {
  return {
    type: actionTypes.GET_MESSAGE_XML_SUCCESS,
    payload
  };
}

export function getMessageXmlFail(payload) {
  return {
    type: actionTypes.GET_MESSAGE_XML_FAIL,
    payload
  };
}
